import { getPlatformId as m, getRegistryUrl as u } from "../../stores/config.js";
import { requirejsOne as a } from "../require/require.js";
async function l(r, e) {
  if (!e)
    return l(r, m());
  const i = u();
  return await (await a("DS/i3DXCompassPlatformServices/i3DXCompassRegistryClient")).getServicesByPlatform({
    platforms: Array.isArray(e) ? [...e] : [e],
    services: r,
    config: { url: i }
  });
}
async function P(r, e) {
  const i = await a("DS/i3DXCompassPlatformServices/i3DXCompassPlatformServices");
  function o(t) {
    return r ? !!t[r] : !0;
  }
  return new Promise((t, s) => {
    i.getPlatformServices({
      ...e,
      onComplete(n) {
        if (!n)
          return s(new Error("Platform not found"));
        if (Array.isArray(n)) {
          const f = n.filter(o);
          return f.length ? t(f) : s(new Error("Platform not found"));
        }
        return o(n) ? t(n) : s(new Error("Platform not found"));
      },
      onFailure: s
    });
  });
}
async function g(r) {
  if (!r.tenantId)
    return !1;
  const e = await a("DS/i3DXCompassPlatformServices/i3DXCompassPlatformServices");
  return new Promise((i, o) => {
    e.getPlatformConfig({
      platformId: r.tenantId,
      key: r.key,
      onComplete(t) {
        i(t);
      },
      onFailure: o
    });
  });
}
async function c(r, e) {
  var o, t, s;
  if (!e)
    return c(r, m());
  const i = await l([r], e);
  return i.length && ((s = (t = (o = i[0]) == null ? void 0 : o.services) == null ? void 0 : t.find((n) => n.id.toLowerCase() === r.toLowerCase())) == null ? void 0 : s.url) || "";
}
async function D(r) {
  const e = await a("DS/i3DXCompass/i3DXCompass", !0);
  return new Promise((i, o) => {
    e.getAppInfo({
      appId: r,
      onComplete: (t) => {
        i(t);
      },
      onFailure: o
    });
  });
}
async function S(r) {
  const e = await a("DS/i3DXCompassPlatformServices/i3DXCompassPlatformServices");
  return new Promise((i) => {
    e.getGrantedRoles(
      (o) => {
        let t = o;
        r && (t = o.filter((s) => s.platforms.includes(r))), i(t);
      }
    );
  });
}
export {
  P as getAllPlatformsAvailable,
  D as getAppInfo,
  g as getConfigFromPlatform,
  S as getCurrentUserGrantedRoles,
  c as getServiceUrl,
  l as getServicesUrl
};
